import type {
    AppsExcelDownloadRequestDto,
    AppsSearchRequestDto,
} from "app/pages/sales-intelligence/store/find-apps/types/dto";

export const createExcelExportRequestDto = (
    searchRequestDto: AppsSearchRequestDto,
    data: { apps: readonly string[] } | { count: number },
): AppsExcelDownloadRequestDto => {
    const { includeApps, top }: Pick<AppsExcelDownloadRequestDto, "includeApps" | "top"> =
        "count" in data ? { top: data.count, includeApps: [] } : { includeApps: data.apps };

    return {
        top,
        includeApps,
        ...searchRequestDto,
    };
};
